import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../modules/service/auth.service';

@Component({
  selector: 'app-holl-change-password',
  templateUrl: './holl-change-password.component.html',
  styleUrls: ['./holl-change-password.component.scss']
})
export class HollChangePasswordComponent implements OnInit {

  currentPassword = '';
  newPassword     = '';
  confirmPassword = '';

  showCurrent = false;
  showNew     = false;
  showConfirm = false;

  isSubmitting   = false;
  errorMessage   = '';
  successMessage = '';

  userEmail = '';
  userName  = '';

  constructor(private router: Router, private auth: AuthService) {
    var nav   = this.router.getCurrentNavigation();
    var state = nav && nav.extras && nav.extras.state
      ? nav.extras.state as { email?: string }
      : null;

    if (state && state.email) {
      this.userEmail = state.email;
    }

    // Pull user's display name from the stored session
    var user = this.auth.getUser();
    if (user) {
      var parts     = (user.fullName || '').trim().split(' ');
      this.userName = parts[0] || user.email || '';
      if (!this.userEmail) {
        this.userEmail = user.email || '';
      }
    }
  }

  ngOnInit() {
    // Guard: must have an active session to reach this page
    if (!this.auth.isLoggedIn) {
      this.router.navigate(['']);
    }
  }

  // ── Password strength ─────────────────────────────────────────────────────

  get rules() {
    var p = this.newPassword;
    return {
      length:    p.length >= 8,
      uppercase: /[A-Z]/.test(p),
      lowercase: /[a-z]/.test(p),
      number:    /[0-9]/.test(p),
      special:   /[^A-Za-z0-9]/.test(p)
    };
  }

  get strengthScore(): number {
    var r = this.rules;
    return [r.length, r.uppercase, r.lowercase, r.number, r.special]
      .filter(Boolean).length;
  }

  get strengthLabel(): string {
    var s = this.strengthScore;
    if (s <= 1) { return 'Very weak'; }
    if (s === 2) { return 'Weak'; }
    if (s === 3) { return 'Fair'; }
    if (s === 4) { return 'Good'; }
    return 'Strong';
  }

  get strengthClass(): string {
    var s = this.strengthScore;
    if (s <= 1) { return 'very-weak'; }
    if (s === 2) { return 'weak'; }
    if (s === 3) { return 'fair'; }
    if (s === 4) { return 'good'; }
    return 'strong';
  }

  get passwordsMatch(): boolean {
    return this.newPassword.length > 0 && this.newPassword === this.confirmPassword;
  }

  get formValid(): boolean {
    return (
      this.currentPassword.trim().length > 0 &&
      this.strengthScore >= 3 &&
      this.passwordsMatch
    );
  }

  // ── Submit ────────────────────────────────────────────────────────────────

  submit(event: Event) {
    event.preventDefault();
    this.errorMessage   = '';
    this.successMessage = '';

    if (!this.currentPassword.trim()) {
      this.errorMessage = 'Please enter your current (default) password.';
      return;
    }

    if (this.strengthScore < 3) {
      this.errorMessage = 'Your new password is too weak. Please follow the rules below.';
      return;
    }

    if (!this.passwordsMatch) {
      this.errorMessage = 'New passwords do not match.';
      return;
    }

    if (this.currentPassword === this.newPassword) {
      this.errorMessage = 'Your new password must be different from your current password.';
      return;
    }

    this.isSubmitting = true;

    this.auth.changePassword({
      email:           this.userEmail,
      currentPassword: this.currentPassword,
      newPassword:     this.newPassword
    }).subscribe(
      (res) => {
        this.isSubmitting = false;

        if (res.responseCode === '000') {
          this.successMessage = 'Password updated successfully! Taking you to your dashboard…';
          var self = this;
          setTimeout(function() { self.router.navigate(['products']); }, 1600);
        } else {
          this.errorMessage = res.responseMessage || 'Failed to change password. Please try again.';
        }
      },
      (err) => {
        this.isSubmitting = false;
        this.errorMessage = err && err.error && err.error.responseMessage
          ? err.error.responseMessage
          : 'Something went wrong. Please check your connection and try again.';
      }
    );
  }

  skipForNow() {
    // Allow user to skip for this session — they will be prompted again next login
    this.router.navigate(['products']);
  }
}
